import { RSAA } from 'redux-api-middleware';
import { get, forEach } from 'lodash';

import endpoints from '../../utils/endpoints';
import { REVIEWED, VERIFIED, SOFT } from '../../constants/Constants';
import {
	getAccountsWithPaymentReadAction,
	getAccountsWithTransactionRead,
	transactionReadCapability,
	paymentReadCapability,
} from '../accounts/selectors';
import { getIsLCV } from '../session/selectors';
import { getAccountsByCapability, getMissingAccountsForPaymentLibAuth } from '../accounts/actions';

export const GO_BACK_PAGE = 'GO_BACK_PAGE';

export const GET_ALL_MISSING_DETAILS_REQUEST = 'GET_ALL_MISSING_DETAILS_REQUEST';
export const GET_ALL_MISSING_DETAILS_SUCCESS = 'GET_ALL_MISSING_DETAILS_SUCCESS';
export const GET_ALL_MISSING_DETAILS_FAILURE = 'GET_ALL_MISSING_DETAILS_FAILURE';

export const FETCH_MY_PAYMENTS_TO_AUTHORISE_REQUEST = 'FETCH_MY_PAYMENTS_TO_AUTHORISE_REQUEST';
export const FETCH_MY_PAYMENTS_TO_AUTHORISE_SUCCESS = 'FETCH_MY_PAYMENTS_TO_AUTHORISE_SUCCESS';
export const FETCH_MY_PAYMENTS_TO_AUTHORISE_FAILURE = 'FETCH_MY_PAYMENTS_TO_AUTHORISE_FAILURE';

export const FETCH_OTHER_USER_PAYMENTS_TO_AUTHORISE_REQUEST = 'FETCH_OTHER_USER_PAYMENTS_TO_AUTHORISE_REQUEST';
export const FETCH_OTHER_USER_PAYMENTS_TO_AUTHORISE_SUCCESS = 'FETCH_OTHER_USER_PAYMENTS_TO_AUTHORISE_SUCCESS';
export const FETCH_OTHER_USER_PAYMENTS_TO_AUTHORISE_FAILURE = 'FETCH_OTHER_USER_PAYMENTS_TO_AUTHORISE_FAILURE';

export const FETCH_ALL_ACCOUNT_PAYMENTS_TO_AUTHORISE_REQUEST = 'FETCH_ALL_ACCOUNT_PAYMENTS_TO_AUTHORISE_REQUEST';
export const FETCH_ALL_ACCOUNT_PAYMENTS_TO_AUTHORISE_SUCCESS = 'FETCH_ALL_ACCOUNT_PAYMENTS_TO_AUTHORISE_SUCCESS';
export const FETCH_ALL_ACCOUNT_PAYMENTS_TO_AUTHORISE_FAILURE = 'FETCH_OTHER_USER_PAYMENTS_TO_AUTHORISE_FAILURE';

export const UPDATE_VERIFICATION_STATUS_REQUEST = 'UPDATE_VERIFICATION_STATUS_REQUEST';
export const UPDATE_VERIFICATION_STATUS_SUCCESS = 'UPDATE_VERIFICATION_STATUS_SUCCESS';
export const UPDATE_VERIFICATION_STATUS_FAILURE = 'UPDATE_VERIFICATION_STATUS_FAILURE';

export const UPDATE_VERIFICATION_SUBMISSION_DATE_REQUEST = 'UPDATE_VERIFICATION_SUBMISSION_DATE_REQUEST';
export const UPDATE_VERIFICATION_SUBMISSION_DATE_SUCCESS = 'UPDATE_VERIFICATION_SUBMISSION_DATE_SUCCESS';
export const UPDATE_VERIFICATION_SUBMISSION_DATE_FAILURE = 'UPDATE_VERIFICATION_SUBMISSION_DATE_FAILURE';

export const GO_TO_ACCOUNTS = 'GO_TO_ACCOUNTS';
export const CLOSE_ALERT = 'CLOSE_ALERT';

export const goBackPage = () => ({
	type: GO_BACK_PAGE,
});

export const goToAccounts = () => ({
	type: GO_TO_ACCOUNTS,
});

export const fetchMyPaymentsToAuthorise = () => {
	const endpoint = endpoints.allVerifications;

	return {
		[RSAA]: {
			endpoint: endpoint.uri,
			method: endpoint.method,
			types: [
				FETCH_MY_PAYMENTS_TO_AUTHORISE_REQUEST,
				FETCH_MY_PAYMENTS_TO_AUTHORISE_SUCCESS,
				FETCH_MY_PAYMENTS_TO_AUTHORISE_FAILURE,
			],
			headers: { 'x-bpi-version': endpoint.x_bpi_version },
		},
	};
};

export const fetchOtherPaymentsToAuthorise = (accounts) => {
	const account_list = accounts.map((account) => account.id);
	const body = JSON.stringify({ account_list, user_search_type: 'creator' });
	const endpoint = endpoints.userApprovals;

	return {
		[RSAA]: {
			endpoint: endpoint.uri,
			method: endpoint.method,
			types: [
				FETCH_OTHER_USER_PAYMENTS_TO_AUTHORISE_REQUEST,
				FETCH_OTHER_USER_PAYMENTS_TO_AUTHORISE_SUCCESS,
				FETCH_OTHER_USER_PAYMENTS_TO_AUTHORISE_FAILURE,
			],
			body,
			headers: { 'x-bpi-version': endpoint.x_bpi_version },
		},
	};
};

export const fetchAllAccountPaymentsToAuthorise = (accounts) => {
	const account_list = accounts.map((account) => account.id);
	const body = JSON.stringify({ account_list });
	const endpoint = endpoints.approvals;

	return {
		[RSAA]: {
			endpoint: endpoint.uri,
			method: endpoint.method,
			types: [
				FETCH_ALL_ACCOUNT_PAYMENTS_TO_AUTHORISE_REQUEST,
				FETCH_ALL_ACCOUNT_PAYMENTS_TO_AUTHORISE_SUCCESS,
				FETCH_ALL_ACCOUNT_PAYMENTS_TO_AUTHORISE_FAILURE,
			],
			body,
			headers: { 'x-bpi-version': endpoint.x_bpi_version },
		},
	};
};

const getFromAndToAccount = (entry) => ({
	from_account: get(entry, 'from_account'),
	to_account: get(entry, 'to_account'),
});

const getArrayOfPayments = (payment) => {
	if (Array.isArray(payment)) {
		return payment;
	}
	return [payment];
};

export const getFromAndToAccounts = (responses = []) => {
	const missingDetails = [];
	responses.map((response) => {
		if (response.type === FETCH_MY_PAYMENTS_TO_AUTHORISE_SUCCESS) {
			const verificationList = get(response, 'payload.verification_list', []);
			forEach(verificationList, (verification) => {
				const chaps = getArrayOfPayments(get(verification, 'chaps', []));
				const payments = getArrayOfPayments(get(verification, 'payments', []));
				const ift = getArrayOfPayments(get(verification, 'ift', []));
				const bacs = getArrayOfPayments(get(verification, 'bacs', []));
				forEach(chaps, (entry) => missingDetails.push(getFromAndToAccount(entry)));
				forEach(payments, (entry) => missingDetails.push(getFromAndToAccount(entry)));
				forEach(ift, (entry) => missingDetails.push(getFromAndToAccount(entry)));
				forEach(bacs, (entry) => {
					missingDetails.push({
						from_account: get(entry, 'account'),
					});
				});
			});
		}
		if (response.type === FETCH_OTHER_USER_PAYMENTS_TO_AUTHORISE_SUCCESS) {
			const approvalsList = get(response, 'payload.approvals', []);
			forEach(approvalsList, (approval) => missingDetails.push(getFromAndToAccount(approval)));
		}
		if (response.type === FETCH_ALL_ACCOUNT_PAYMENTS_TO_AUTHORISE_SUCCESS) {
			const approvalsList = get(response, 'payload.approvals', []);
			const approvalsChaps = get(response, 'payload.approvals_chaps', []);
			const approvalsBacs = get(response, 'payload.approvals_bacs', []);
			const approvalsIft = get(response, 'payload.approvals_ift', []);
			forEach(approvalsList, (approval) => missingDetails.push(getFromAndToAccount(approval)));
			forEach(approvalsChaps, (approval) => missingDetails.push(getFromAndToAccount(approval)));
			forEach(approvalsIft, (approval) => missingDetails.push(getFromAndToAccount(approval)));
			forEach(approvalsBacs, (approval) => missingDetails.push({ from_account: get(approval, 'account') }));
		}
		return null;
	});
	return missingDetails;
};

export const fetchBootstrapCalls = (dispatch, getState) => {
	const state = getState();
	const userOnlyAccounts = getAccountsWithPaymentReadAction(state);
	const allAccounts = getAccountsWithTransactionRead(state);
	return Promise.all([
		dispatch(fetchMyPaymentsToAuthorise()),
		userOnlyAccounts.length && dispatch(fetchOtherPaymentsToAuthorise(userOnlyAccounts)),
		allAccounts.length && dispatch(fetchAllAccountPaymentsToAuthorise(allAccounts)),
	]);
};

export const handleLoad = () => (dispatch, getState) => {
	const state = getState();
	const isLCV = getIsLCV(state);
	if (isLCV) {
		return Promise.all([
			dispatch(getAccountsByCapability(transactionReadCapability)),
			dispatch(getAccountsByCapability(paymentReadCapability)),
		]).then(() =>
			fetchBootstrapCalls(dispatch, getState).then((responses) =>
				dispatch(getMissingAccountsForPaymentLibAuth(getFromAndToAccounts(responses))).then(() => responses)
			)
		);
	}
	return fetchBootstrapCalls(dispatch, getState);
};

const updateVerification = (paymentId, types, body) => {
	const endpoint = endpoints.updateVerification;
	const uri = endpoint.uri.replace(':verificationId', paymentId);

	return {
		[RSAA]: {
			endpoint: uri,
			method: endpoint.method,
			types,
			body: JSON.stringify(body),
			headers: { 'x-bpi-version': endpoint.x_bpi_version },
		},
	};
};

export const updateVerificationStatus = (paymentId, status) => {
	const types = [
		UPDATE_VERIFICATION_STATUS_REQUEST,
		{
			type: UPDATE_VERIFICATION_STATUS_SUCCESS,
			meta: { status },
		},
		{
			type: UPDATE_VERIFICATION_STATUS_FAILURE,
			meta: { status },
		},
	];
	return updateVerification(paymentId, types, { status });
};

export const updateVerificationSubmissionDate = (paymentDetails, newSubmissionDate, ratesInformation = {}) => {
	const {
		toAuthorise: { verification_id, verification_type },
	} = paymentDetails;
	const types = [
		UPDATE_VERIFICATION_SUBMISSION_DATE_REQUEST,
		UPDATE_VERIFICATION_SUBMISSION_DATE_SUCCESS,
		UPDATE_VERIFICATION_SUBMISSION_DATE_FAILURE,
	];
	const paymentStatus = verification_type === SOFT ? REVIEWED : VERIFIED;
	const body = {
		status: paymentStatus,
		new_submission_date: newSubmissionDate,
		...ratesInformation,
	};
	return updateVerification(verification_id, types, body);
};

export const declinePayment = (paymentId) => (dispatch) =>
	dispatch(updateVerificationStatus(paymentId, 'DECLINED')).then((response) => response);

export const cancelPayment = (paymentId) => (dispatch) =>
	dispatch(updateVerificationStatus(paymentId, 'CANCELLED')).then((response) => response);
export const expireMultiplePayments = (paymentsToExpire) => (dispatch) =>
	paymentsToExpire.forEach(({ id: paymentId }) => {
		dispatch(updateVerificationStatus(paymentId, 'EXPIRED'));
	});

export const acceptNewDates =
	(paymentDetails, newSubmissionDate, ratesInformation = {}) =>
	(dispatch) =>
		dispatch(
			updateVerificationSubmissionDate(paymentDetails, newSubmissionDate.format('YYYY-MM-DD'), ratesInformation)
		);

export const reviewPayment = (paymentId) => (dispatch) =>
	dispatch(updateVerificationStatus(paymentId, REVIEWED)).then((response) => response);

export const closeAlert = (value) => ({
	type: CLOSE_ALERT,
	value,
});
